import React from "react";
import "./Footer.scss";

const Footer = ({ onOpenLegalModal }) => {
  return (
    <footer className="footer-container">
      <div className="footer-left">
        <h3>SBHM Concept</h3>
        <p>2024 © SBHM Concept, tous droits réservés.</p>
        <a
          href="https://github.com/CorentinDNT"
          target="_blank"
          rel="noopener noreferrer"
          className="corentin"
        >
          Conception: Corentin DONATO - développeur web
        </a>
      </div>

      <div className="footer-right">
        <a className="footer-right-phone footer" href="tel:0631346643">
          Téléphone: 0631346643
        </a>
        <p>
          Horaires: Lundi au Vendredi - <b>8h - 19h</b>
        </p>
        <ul>
          <li onClick={onOpenLegalModal}>Mentions légales</li>{" "}
        </ul>
      </div>
    </footer>
  );
};

export default Footer;
